var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H5.625C2.5184 0 0 2.5184 0 5.625V18.375C0 21.4816 2.5184 24 5.625 24H18.375C21.4816 24 24 21.4816 24 18.375V5.625C24 2.5184 21.4816 0 18.375 0Z",
    fill: "#F0DB4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3104 20.0559L8.14696 18.9444C8.50133 19.5727 8.82365 20.1042 9.5968 20.1042C10.3379 20.1042 10.8051 19.8143 10.8051 18.6867V11.0182H13.0606V18.7186C13.0606 21.0546 11.6913 22.1179 9.69346 22.1179C7.88924 22.1179 6.84196 21.1835 6.3103 20.0558M14.2856 19.8143L16.122 18.751C16.6055 19.5405 17.2338 20.1204 18.3453 20.1204C19.2799 20.1204 19.8757 19.6532 19.8757 19.0088C19.8757 18.2355 19.2636 17.9616 18.2325 17.5106L17.6688 17.2688C16.0416 16.5762 14.9621 15.7062 14.9621 13.8697C14.9621 12.178 16.251 10.8892 18.2648 10.8892C19.6986 10.8892 20.7297 11.3887 21.4707 12.6936L19.7147 13.8213C19.328 13.1286 18.9093 12.8547 18.2648 12.8547C17.6043 12.8547 17.1854 13.2736 17.1854 13.8213C17.1854 14.4979 17.6043 14.7718 18.5708 15.1908L19.1346 15.4324C21.0517 16.2541 22.1312 17.0917 22.1312 18.9765C22.1312 21.0066 20.5363 22.1181 18.3936 22.1181C16.2994 22.1181 14.9461 21.1193 14.2856 19.8143Z",
    fill: "#323330"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.d2b270c4fea128c4857948f80f03d437.svg";
export { ForwardRef as ReactComponent };